<div [classList]="'badge ' + size">
  <app-icon [type]="type" [icon]="icon"></app-icon>
</div>
